import React from 'react'
import { AD, ADVERTISEMENT, HIGHLIGHT, MOVIE, WEISCHER } from '../../constants/itemTypes'

const MoviesPerCinemaList = ({cinemaPk, cliMovies, collectionItems, highlightsItems, adsItems, advertisementsItems, weischerAdsItems}) => {
    return collectionItems.map((collectionItem) => {
        const {id, type}= collectionItem

        
        if(type === MOVIE) {
            const cliMovie = cliMovies[id]
            if(!cliMovie) {
                return
            }

            const {cinemaIds, title, titleDisplay} = cliMovie

            if(_.contains(cinemaIds, cinemaPk)) {
                return <div key={id} className="text-small-light items-per-cinema">{titleDisplay ? titleDisplay : title}</div>
            }

        } else if(type === AD) {
            const adItem = adsItems[id]
            if(!adItem) {
                return
            }
            
            const {cinemas, title, cinemasFilter} = adItem
            const cinemasArray = cinemasFilter ? cinemasFilter : cinemas

            if(_.contains(cinemasArray, cinemaPk)) {
                return <div key={id} className="text-small-light items-per-cinema">{title}</div>
            }

        } else if(type === HIGHLIGHT) {
            const highlightsItem = highlightsItems[id]
            if(!highlightsItem) {
                return
            }
            
            const {cinemas, title, cinemasFilter} = highlightsItem
            const cinemasArray = cinemasFilter ? cinemasFilter : cinemas

            if(_.contains(cinemasArray, cinemaPk)) {
                return <div key={id} className="text-small-light items-per-cinema">{title}</div>
            }
        } else if(type === WEISCHER) {
            const weischerAdsItem = weischerAdsItems[id]
            if(!weischerAdsItem) {
                return
            }
            
            const {cinemas, payload, cinemasFilter} = weischerAdsItem
            const cinemasArray = cinemasFilter ? cinemasFilter : cinemas

            if(_.contains(cinemasArray, cinemaPk)) {
                return <div key={id} className="text-small-light items-per-cinema">Weischer {payload}</div>
            }
        } else if(type === ADVERTISEMENT) {
            const advertisementItem = advertisementsItems[id]
            if(!advertisementItem) {
                return
            }

            const {cinemas, title, cinemasFilter} = advertisementItem
            const cinemasArray = cinemasFilter ? cinemasFilter : cinemas

            if(_.contains(cinemasArray, cinemaPk)) {
                return <div key={id} className="text-small-light items-per-cinema">{title}</div>
            }
        } else {
            return ''
        }
    })
}

export default MoviesPerCinemaList
